"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGreaterThanOrEqual = void 0;
exports.isGreaterThanOrEqual = (a, b) => a >= b;
//# sourceMappingURL=is-greater-than-or-equal.js.map